import _sfc_main from "./UserInfoH5.vue2.mjs";
/* empty css                 */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.userInfoConfig.visible ? _c("div", { ref: "userInfoRef", staticClass: "user-info-container" }, [_c("div", { directives: [{ name: "tap", rawName: "v-tap", value: _setup.handleUserControl, expression: "handleUserControl" }], staticClass: "user-info-content" }, [_c(_setup.Avatar, { staticClass: "avatar", attrs: { "img-src": _vm.avatarUrl } }), _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.userName || _vm.userId))])], 1), _setup.showUserControl ? _c("div", { staticClass: "user-control-container" }, [_c("div", { staticClass: "logout-mobile" }, [_c("div", { staticClass: "logout-mobile-main" }, [_c("div", { directives: [{ name: "tap", rawName: "v-tap", value: () => _vm.$emit("log-out"), expression: "() => $emit('log-out')" }], staticClass: "logout" }, [_c("i", [_vm._v(" " + _vm._s(_setup.t("Log out")))])]), _c("div", { staticClass: "close", on: { "click": function($event) {
    $event.stopPropagation();
    _setup.showUserControl = false;
  } } }, [_c("i", [_vm._v(_vm._s(_setup.t("Cancel")))])])])])]) : _vm._e()]) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "a4ccc14d"
);
const UserInfoH5 = __component__.exports;
export {
  UserInfoH5 as default
};
